const STATS = [
  { value: "25,800+", label: "在库影视" },
  { value: "免费", label: "在线观看" },
  { value: "1080P", label: "高清画质" },
  { value: "多端", label: "PC 与手机" },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-5">
        <div className="lg:col-span-3 p-6 md:p-9">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500/15 text-secondary-300 text-xs font-medium font-label">
            <i className="ri-leaf-line" />
            关于桔子TV
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-4 leading-snug">
            专注于影视内容的在线观看与信息展示
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-4">
            桔子TV 以电视剧《好好的时光》为特色内容，聚合都市、年代、古装、爱情、悬疑等多元题材，覆盖电视剧、电影与综艺三大频道。我们致力于让观众快速找到想看的作品，通过清晰的分类筛选、详尽的剧集目录与相关推荐，带来流畅、便捷的追剧体验。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mt-3">
            支持 PC 与手机端随时浏览，收藏喜欢的作品以便下次快速找回。本站影视信息用于内容展示，播放区域为功能演示，不提供真实视频流。
          </p>
        </div>
        <div className="lg:col-span-2 grid grid-cols-2 border-t lg:border-t-0 lg:border-l border-background-200">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="p-5 md:p-6 flex flex-col justify-center border-b border-r border-background-200 last:border-b-0"
            >
              <span className="font-heading text-2xl md:text-3xl font-extrabold text-primary-500">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-600 mt-1.5">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}